module.exports = __webpack_public_path__ + "img/bk_red1.c14f5009.png";